import { css } from '@emotion/core';

import {
  flex,
  flexCenter,
  flexDirectionColumn,
  SPACE_COMFORTABLE,
  SPACE_COMPACT,
  SPACE_COZY,
} from '@/styles';

export const detectorsStyles = css`
  padding: ${SPACE_COZY}px ${SPACE_COMFORTABLE}px;
  min-width: 600px;
  min-height: 60px;
  ${flex};
  ${flexDirectionColumn};
  table {
    tbody {
      font-size: 13px;
      tr td {
        padding-top: ${SPACE_COMPACT}px;
        padding-bottom: ${SPACE_COMPACT}px;
        code {
          font-size: 12px;
        }
      }
    }
  }
`;

export const spinnerStyles = css`
  ${flexCenter};
  flex-grow: 1;
`;
